import { Box, Typography, useTheme } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';
import { ComponentProps, useMemo } from 'react';
import { CustomBr, CustomLink } from './Component';
import { createMarkdownStyles } from './styles';

type CustomMDPreviewProps = {
    description?: string;
    customStyles?: any;
    onCheckboxChange?: (str: string, index: number) => void;
} & ComponentProps<typeof MDEditor.Markdown>

const CustomMDPreview = ({
    description,
    customStyles = {},
    onCheckboxChange,
    ...props
}: CustomMDPreviewProps) => {
    const getCheckboxIndex = (element: HTMLElement): number => {
        const container = element.closest('.wmde-markdown');
        if (!container) return 0;
        const allCheckboxes = Array.from(container.querySelectorAll('input[type="checkbox"]'));
        return allCheckboxes.indexOf(element as HTMLInputElement);
    };
    const theme = useTheme();
    const markdownStyles = useMemo(() => createMarkdownStyles(theme), [theme]);

    if (!description) {
        return <Box
            sx={markdownStyles}
        >
            <Typography color="text.secondary" variant="subtitle2">-</Typography>
        </Box>;
    }

    return (
        <Box sx={{ ...markdownStyles, ...customStyles }}>
            <MDEditor.Markdown
                source={description}
                components={{
                    p: ({ children }) => {
                        return <p style={{ whiteSpace: 'pre-line' }}>{children}</p>;
                    },
                    input: ({ checked, node, ...props }) => {
                        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                            const element = e.target;
                            const index = getCheckboxIndex(element);
                            onCheckboxChange?.(description || '', index);
                        };

                        return (
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={handleChange}
                            />
                        );
                    },
                    br: () => <CustomBr />,
                    a: (props) => <CustomLink {...props} />,
                }}
                {...props}
            />
        </Box>
    );
};

export default CustomMDPreview;